import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	bottom: 80px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	gap: 20px;
	align-items: end;
	justify-content: center;
`;

export { StyledContainer };
